import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";

type AppCustomPropertyCheckboxSingleProps = {
  customProperty: CustomProperty;
  data: any;
  validate: boolean;
  onChange: (label: string, data: any) => void;
};

export const AppCustomPropertyCheckboxSingle = ({
  customProperty,
  data,
  validate,
  onChange,
}: AppCustomPropertyCheckboxSingleProps) => {
  const [checked, setChecked] = useState<boolean>(
    data ? data : JSON.parse(customProperty.settings || "{}").checked || false
  );

  useEffect(() => {
    onChange(customProperty.label, checked);
  }, [checked]);

  return (
    <div className="app-custom-property-checkboxsingle">
      <input
        title={customProperty.label}
        type="checkbox"
        name={customProperty.label}
        checked={checked}
        onChange={(event) => {
          setChecked(event.target.checked);
        }}
      />
    </div>
  );
};
